const sites = "ILO";
const baseURL = process.env.REACT_APP_USER_ACCESS_API_URL;
const commonURL = process.env.REACT_APP_ASSESS_API_BASEURL;

// Helper for Authorization header
const authHeader = () => {
    const token = localStorage.getItem("token") || "";
    return { Authorization: `Bearer ${token}` };
};

// --------------------------
// Add-ons List
// --------------------------
export const getAllAddonsListApi = async () => {
    const axios = (await import("axios")).default;

    try {
        const res = await axios.get(
            `${baseURL}zoho/addon?sites=${sites}`,
            { headers: authHeader() }
        );
        return res.data;
    } catch (error) {
        console.error(error.message, "errorMessageData");
    }
};

// --------------------------
// Plans List
// --------------------------
export const getAllPlansList = async ({ tenure, user_type, section = "" }) => {
    const axios = (await import("axios")).default;

    try {
        const url = `${baseURL}zoho/plan?user_type=${user_type}&sites=${sites}&tenure=${tenure}${
            section ? `&section=${section}` : ""
        }`;

        const res = await axios.get(url, { headers: authHeader() });
        return res.data;
    } catch (error) {
        console.log(error.message, "errorMessageData");
    }
};

// --------------------------
// Subscription Details
// --------------------------
export const getSubscriptionApi = async (userId) => {
    const axios = (await import("axios")).default;

    try {
        const res = await axios.get(
            `${baseURL}zoho/subscription/${userId}`,
            { headers: authHeader() }
        );
        return res.data;
    } catch (err) {
        return err;
    }
};

// --------------------------
// Create Zoho Subscription
// --------------------------
export const createZohoSubscription = async (payload) => {
    const axios = (await import("axios")).default;

    try {
        const res = await axios.post(
            `${baseURL}zoho/subscription/create`,
            payload,
            {
                headers: {
                    "Content-Type": "application/json",
                    ...authHeader(),
                },
            }
        );
        return res.data;
    } catch (error) {
        console.log(error.message, "errorMessageData");
    }
};

// --------------------------
// State List
// --------------------------
export const getSubscriptionStateList = async (id) => {
    const axios = (await import("axios")).default;

    try {
        const res = await axios.get(
            `${commonURL}states/${id}`,
            { headers: authHeader() }
        );
        return res.data?.data;
    } catch (error) {
        console.log(error.message, "errorMessageData");
    }
};

// --------------------------
// City List
// --------------------------
export const getSubscriptionCityList = async (id) => {
    const axios = (await import("axios")).default;

    try {
        const res = await axios.get(
            `${commonURL}cities/${id}`,
            { headers: authHeader() }
        );
        return res.data?.data;
    } catch (error) {
        console.log(error.message, "errorMessageData");
    }
};

// --------------------------
// Coupons
// --------------------------
export const getCouponListApi = async (planCode) => {
    const axios = (await import("axios")).default;

    try {
        const res = await axios.get(
            `${baseURL}zoho/coupon?plan_code=${planCode}&product_name=Lexops`,
            { headers: authHeader() }
        );
        return res.data;
    } catch (error) {
        console.error(error.message, "errorMessageData");
    }
};

// --------------------------
// Countries List
// --------------------------
export const getSubscriptionCountriesList = async () => {
    const axios = (await import("axios")).default;

    try {
        const res = await axios.get(
            `${commonURL}countries`,
            { headers: authHeader() }
        );
        return res.data?.data;
    } catch (error) {
        console.log(error.message, "errorMessageData");
    }
};

// --------------------------
// Cancel Subscription
// --------------------------
export const cancelZohoSubscription = async (subscriptionId) => {
    const axios = (await import("axios")).default;

    try {
        const res = await axios.post(
            `${baseURL}zoho/subscription/cancel_current_subscription`,
            { subscription_ids: subscriptionId },
            {
                headers: {
                    "Content-Type": "application/json",
                    ...authHeader(),
                },
            }
        );
        return res.data;
    } catch (err) {
        return err;
    }
};

// --------------------------
// Create Subscription
// --------------------------
export const createSubscription = async (payload) => {
    const axios = (await import("axios")).default;

    try {
        const res = await axios.post(
            `${baseURL}zoho/subscription`,
            payload,
            {
                headers: {
                    "Content-Type": "application/json",
                    ...authHeader(),
                },
            }
        );
        return res.data;
    } catch (err) {
        return err;
    }
};
